import PageTeacherSignup from "./PageTeacherSignup";
import PageLogin from "./PageLogin";
import PageVerifyEmail from "./PageVerifyEmail";
import PageCreateVirtualClass from "./PageCreateVirtualClass";
import PageAddStudentToClass from "./PageAddStudentToClass";
import PageStudentInvite from "./PageClassInvite";
import PageStudentCompleteProfile from "./PageStudentCompleteProfile";
import PageStudentAcceptInvite from "./PageStudentAcceptInvite";
import PageStudentUpcomingClass from "./PageStudentUpcomingClass";
import PageTeacherHome from "./PageTeacherHome";
import PageStartLiveClass from "./PageStartLiveClass";
import PageEditTeacherProfile from './PageEditTeacherProfile'
import PageEditStudentProfile from './PageEditStudentProfile';
import PagePageNotFound from "./PagePageNotFound";
import PageTeacherCompleteProfile from './PageTeacherCompleteProfile';
import PageAddingContent from './PageAddingContent';
import PageCreateClassPlan from './PageCreateClassPlan';
import PageClassInfo from './PageClassInfo';
import PageInitializeClassPlan from "./PageInitializeClassPlan";
import PageAddingAssignment from './PageAddingAssignment';
import FieldTimeCoverInput from "../formFields/FieldTimeCover";
import PageAddingQuestion from './PageAddingQuestion';
import TeachersDashboard from "./dashboard/PageTeachersDashboard";
import TeachersAttendance from "./dashboard/PageTeachersAttendance";
import TeachersDoubts from "./dashboard/PageTeachersDoubts";
export default {
    PageTeacherSignup,
    PageLogin,
    PageVerifyEmail,
    PageStudentInvite,
    PageCreateVirtualClass,
    PageAddStudentToClass,
    PageStudentCompleteProfile,
    PageStudentAcceptInvite,
    PageStudentUpcomingClass,
    PageTeacherHome,
    PageStartLiveClass,
    PageEditTeacherProfile,
    PageEditStudentProfile,
    PagePageNotFound,
    PageTeacherCompleteProfile,
    PageAddingContent,
    PageCreateClassPlan,
    PageClassInfo,
    PageInitializeClassPlan,
    PageAddingAssignment,
    FieldTimeCoverInput,
    PageAddingQuestion,
    TeachersDashboard,
    TeachersAttendance,
    TeachersDoubts,
}
